import _ from 'lodash';
import Promise from 'bluebird';
import { singular, plural } from 'pluralize';
import URI from 'urijs';

import {
    generateResourceStore,
    generateResourceGetters,
    generateResourceActions,
    generateResourceMutations,
} from '../generators';

// initial state
const createState = (helpers) => {
    return {
        ...generateResourceStore(),
        content: null,
        loading: false,
        path: '/assets',
        selectingAsset: null,
        selectedAsset: null,
        fileModalOpen: false,
        fileModalConfig: {},
    }
}

// getters
const getters = {
    ...generateResourceGetters(),
    selectingAsset: (state) => state.selectingAsset,
    selectedAsset: (state) => state.selectedAsset,
    fileModalOpen: (state) => state.fileModalOpen,
    fileModalConfig: (state) => state.fileModalConfig,
}

// actions
const createActions = (helpers) => ({
    ...generateResourceActions(helpers),

    getInitialData({ commit }, url) {
        const path = helpers.uriFormat(url);
        commit('setPath', path);
        commit('processing');

        return helpers.api.getData(path)
            .then(res => {
                commit('setContent', res);
            })
            .finally(() => commit('idle'))
    },

    selectAsset({ commit }, asset) {
        commit('selectAsset', asset);
    },

    commitAsset({ commit }) {
        commit('commitAsset')
    },

    configAssetModal({ commit }, config) {
        commit('configAssetModal', config)
    },

    closeAssetModal({ commit }) {
        commit('closeAssetModal');
    },

    openAssetModal({ commit }) {
        commit('openAssetModal');
    },

})

// mutations
const mutations = {
    ...generateResourceMutations(),

    selectAsset(state, asset) {
        state.selectingAsset = asset;
    },

    commitAsset(state) {
        state.selectedAsset = state.selectingAsset;
    },

    closeAssetModal(state) {
        state.fileModalOpen = false;
    },

    openAssetModal(state) {
        state.fileModalOpen = true;
    },

    configAssetModal(state, config) {
        state.fileModalConfig = config;
    },
}

export default (helpers) => {
    return Promise.all([
        createState(helpers),
        createActions(helpers),
    ])
        .then(([state, actions]) => ({
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }))
}



// WEBPACK FOOTER //
// ./seventytwo/72cms-ui/src/store/modules/assets.js